import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import FullNavLayout from "../../layout/FullNavLayout";
import "react-phone-input-2/lib/bootstrap.css";
import "./auth.scss";
import { api } from "../../utils/constants";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Helmet } from "react-helmet";

function ForgetPasscodeNumber() {
  const [error, setError] = useState(false);
  const [otp, setOtp] = useState(false);
  const [res, setRes] = useState(false);

  const [number, setNumber] = useState("");
  const [mail, setmail] = useState("");
  const [country, setCountry] = useState();
  const [mobileView, setMobileView] = useState(false);

  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((res) => {
        setCountry(res.country_code.toLowerCase());
      })
      .catch((data, status) => {
        console.log("Request failed:", data);
      });
  }, []);

  let history = useHistory();
  const handleSubmit = async (e) => {
    e.preventDefault();
    localStorage.clear();
    console.log(number, mail);
    localStorage.setItem("forgetData", JSON.stringify({ number, mail }));
    if (number !== null && number !== "" && mail !== null && mail !== "") {
      const mobile = number;
      const email = mail;
      const val = { mobile, email };
      await axios.post(api.resetpassword, val).then(
        (response) => {
          setOtp(true);
          setTimeout(function () {
            history.push("/forgetPin");
          }, 2000);
        },
        (error) => {
          setRes(true);
        }
      );
    } else {
      setError(true);
    }
  };
  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 768
        ? setMobileView(true)
        : setMobileView(false);
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);

  return (
    <FullNavLayout>
      <Helmet>
        <title>Diagnostics.doctall.com | Forgot Password
</title>
<meta 
            name='description' 
            content='Forgot Password? Click to reset your password'
            />
      </Helmet>
      <div className="forgotContainer">
        {mobileView ? (
          <div>
            <div style={{ textAlign: "left" }}>
              <>
                <svg
                  width="9"
                  height="20"
                  viewBox="0 0 9 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => history.goBack()}
                >
                  <path
                    d="M8.00019 0.00068029C8.12412 0.000680294 8.24805 0.0481132 8.34258 0.142645C8.53164 0.331708 8.53164 0.638352 8.34258 0.827749L1.16986 8.0008L5.93753 12.7688C6.12659 12.9579 6.12659 13.2645 5.93753 13.4539C5.74847 13.643 5.44182 13.643 5.25243 13.4539L0.142038 8.34352C-0.0470249 8.15445 -0.0470249 7.84781 0.142038 7.65841L7.65747 0.142645C7.75234 0.0481131 7.87627 0.000680286 8.00019 0.00068029Z"
                    fill="#163E8C"
                  />
                </svg>
                <div
                  class="nav-font"
                  style={{ marginLeft: "8%", marginTop: "-8%" }}
                  onClick={() => history.goBack()}
                >
                  Back
                </div>
              </>
            </div>

            <div>
              <h2>Forgot Passcode</h2>
            </div>
          </div>
        ) : (
          <div class="row">
            <div class="col-md-3 col-sm-6">
              <>
                <svg
                  width="9"
                  height="20"
                  viewBox="0 0 9 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => history.goBack()}
                >
                  <path
                    d="M8.00019 0.00068029C8.12412 0.000680294 8.24805 0.0481132 8.34258 0.142645C8.53164 0.331708 8.53164 0.638352 8.34258 0.827749L1.16986 8.0008L5.93753 12.7688C6.12659 12.9579 6.12659 13.2645 5.93753 13.4539C5.74847 13.643 5.44182 13.643 5.25243 13.4539L0.142038 8.34352C-0.0470249 8.15445 -0.0470249 7.84781 0.142038 7.65841L7.65747 0.142645C7.75234 0.0481131 7.87627 0.000680286 8.00019 0.00068029Z"
                    fill="#163E8C"
                  />
                </svg>

                <div
                  className="nav-font"
                  style={{ marginLeft: "50%", marginTop: "-18%" }}
                  onClick={() => history.goBack()}
                >
                  Back
                </div>
              </>
            </div>
            <div class="col-md-9 col-sm-6">
              <h2>Forgot Passcode</h2>
            </div>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="forgetNumber">
            <label htmlFor="Phone">Phone number</label>
            <PhoneInput
              className="inputPhone"
              country={country}
              value={number}
              onChange={setNumber}
            />
            <label style={{ marginTop: "12px" }} htmlFor="email">
              Email
            </label>
            <input
              className="inputForm"
              type="email"
              name="mail"
              value={mail}
              onChange={(e) => setmail(e.target.value)}
            />
          </div>

          <button type="submit" className="sumbitBtn">
            Send Reset Link
          </button>
          <p>
            You’ll receive the code on your registered phone number and email
            address
          </p>
        </form>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={error}
        autoHideDuration={3000}
        onClose={() => setError(false)}
      >
        <Alert severity="warning">Enter the number and mail-id</Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={otp}
        autoHideDuration={3000}
        onClose={() => setOtp(false)}
      >
        <Alert severity="success">Otp sent!</Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={res}
        autoHideDuration={3000}
        onClose={() => setRes(false)}
      >
        <Alert severity="error">something went wrong!</Alert>
      </Snackbar>
    </FullNavLayout>
  );
}

export default ForgetPasscodeNumber;
